<template>
  <div>
    <v-row>
      <v-col xs='12' sm='6' md='4' lg='3' xl='3' cols='12'>
        <v-btn
          class='warehouseCard warehouseCard-select pa-2'
          tile
          depressed
          @click='$emit("addWarehouseClick")'
        >
          <v-icon
            size='64'
            class='warehouseCard__add-icon'
            color='#00e099'
            tag='div'
          >
            mdi-plus
          </v-icon>
          <span class='mt-2'>Add New Warehouse</span>
        </v-btn>
      </v-col>
      <v-col
        xs='12'
        sm='6'
        md='4'
        lg='3'
        xl='3'
        cols='12'
        v-for='(warehouse, i) in filtredList'
        :key='i + iterator'
      >
        <div
          :class='[
            warehouse.selected ? "warehouseCard--selected" : "",
            "warehouseCard warehouseCard-select",
            "py-3",
            "px-4"
            ]'
          @click='handleCardClick(warehouse)'
          @selectWarehouse='v => { $emit("selectWarehouse", v) }'
        >
          <v-row>
            <v-col cols='auto'>
              <div class='warehouseCard__icon-block'>
                <img class='warehouseCard__icon' src='@/assets/icons/svg/warehouse.svg'>
              </div>
            </v-col>
            <v-col>
              <div>
                <p
                  :style='{
                    fontSize: "1rem",
                    color: warehouse.selected ? "#9e9bd2" : "#000000"
                  }'
                  class='mb-0'
                >
                  <b>{{warehouse.name}}</b>
                </p>
              </div>
              <div>
                <p style='font-size: 0.9rem' class='mb-0'>{{warehouse.description}}</p>
              </div>
            </v-col>
          </v-row>
          <v-divider class='mt-auto' />
          <v-row class='mt-2 mb-0' style='max-height: 45px'>
            <v-col cols='4' style='max-height: 45px; box-sizing: border-box' class='py-0'>
              <p style='display: block;' class='mb-0 text-uppercase text-grey-6 text-center'><b>folders</b></p>
              <p style='display: block;' class='mb-0 text-uppercase text-center'>{{warehouse.info.countCategories}}</p>
            </v-col>
            <v-col cols='4' style='max-height: 45px; box-sizing: border-box' class='py-0'>
              <p style='display: block;' class='mb-0 text-uppercase text-grey-6 text-center'><b>users</b></p>
              <p style='display: block;' class='mb-0 text-uppercase text-center'>{{warehouse.info.countUsers}}</p>
            </v-col>
            <v-col cols='4' style='max-height: 45px; box-sizing: border-box' class='py-0'>
              <p style='display: block;' class='mb-0 text-uppercase text-grey-6 text-center'><b>items</b></p>
              <p style='display: block;' class='mb-0 text-uppercase text-center'>{{warehouse.info.countItems}}</p>
            </v-col>
          </v-row>
        </div>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'syncStep1Select',
  props: {
    haveSelected: {
      required: true
    }
  },
  computed: {
    ...mapGetters('warehouses', {
      warehousesList: 'getWarehousesList'
    }),
    ...mapGetters('integrations', {
      integrationInfo: 'getIntegrationInfo'
    }),
    filtredList() {
      const vm = this
      if (vm.haveSelected.id) {
        const resultArray = vm.warehousesList.map(item => {
          if (vm.haveSelected.id && item.id === vm.haveSelected.id) {
            item.selected = true
          } else {
            item.selected = false
          }
          return item
        })
        if (vm.haveSelected.haveAdded) {
          const sortedResult = resultArray.sort((a, b) => {
            if (a.selected && !b.selected) {
              return -1
            } else if (!a.selected && b.selected) {
              return 1
            } else {
              return 0
            }
          })
          return sortedResult
        } else return resultArray
      } else return vm.warehousesList
    }
  },
  data: () => ({
    iterator: 0
  }),
  methods: {
    handleCardClick(warehouse) {
      this.warehousesList.forEach(item => {
        if (item.id !== warehouse.id) item.selected = false
      })
      warehouse.selected = true

      const warehouseInfo = {
        id: warehouse.id,
        name: warehouse.name,
        description: warehouse.description,
        items: warehouse.info.countItems,
        folders: warehouse.info.countCategories
      }

      this.integrationInfo.warehouse = warehouseInfo
      this.$store.commit('integrations/setIntegrationInfo', this.integrationInfo)

      this.$emit('selectWarehouse', {
        id: warehouse.id,
        warehouse: warehouseInfo,
        haveAdded: false
      })
      this.iterator++
    }
  }
}
</script>
